<template>
  <b-modal
    :visible="visible"
    title="เลือกรายการที่จะใช้บัตร"
    hide-footer
    centered
    @hide="$emit('close')"
  >
    <p class="text-muted">บัตรใบนี้ใช้ได้กับ 1 รายการเท่านั้น</p>

    <b-list-group v-if="lines.length > 0">
      <b-list-group-item
        v-for="line in lines"
        :key="line.treatmentItemId"
        button
        @click="pick(line)"
      >
        <div>{{ line.treatmentName }}</div>
        <small class="text-muted">
          ลด {{ line.discountAmount | comma }} บาท
        </small>
      </b-list-group-item>
    </b-list-group>

    <p v-else class="text-muted mb-0">ไม่มีรายการที่ใช้บัตรใบนี้ได้</p>
  </b-modal>
</template>

<script>
export default {
  name: "VoucherLinePicker",
  props: {
    visible: { type: Boolean, default: false },
    lines: { type: Array, default: () => [] },
  },
  methods: {
    // One code discounts exactly one line, regardless of how many match. Two
    // implants on a receipt take two cards. Auto-picking was rejected in design
    // §2b: silently choosing for the operator is the kind of behaviour nobody
    // notices until it picks the wrong line.
    pick(line) {
      this.$emit("pick", line.treatmentItemId);
    },
  },
};
</script>
